import { ContactInfoModelV3 } from '../model/contactInfo'
import {
  apiGetContactsInfoBySubjectId,
  apiPostContactInfo,
  apiPatchContactInfo,
  apiDeleteContactInfo
} from '../api/Argentia/endpoints/contactsInfo/contactsInfoV3.api'
import { ServiceResponse } from '../model/serviceResponse'
import {
  createErrorServiceResponse,
  createSuccessServiceResponse
} from '../helpers/serviceResponseHelper'
import { contactsInfoItemsMapper } from '../pages/contactsInfo/contactsInfo.mapper'

export const getContactsInfoBySubjectId = async (
  subjectId: number
): Promise<ServiceResponse<any>> => {
  return await apiGetContactsInfoBySubjectId(subjectId)
    .then(response => {
      return createSuccessServiceResponse(contactsInfoItemsMapper(response))
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const postContactInfo = async (
  contactInfo: ContactInfoModelV3
): Promise<ServiceResponse<any>> => {
  return await apiPostContactInfo(contactInfo)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const patchContactInfo = async (
  contactInfo: ContactInfoModelV3
): Promise<ServiceResponse<any>> => {
  return await apiPatchContactInfo(contactInfo)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const deleteContactInfo = async (contactInfoId: number): Promise<any> => {
  return await apiDeleteContactInfo(contactInfoId)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}
